export const ACCEPT_TO_DELIVER = "ACCEPT_TO_DELIVER";
export const PICKEDUP_ORDER = "PICKEDUP_ORDER";
export const REACHED_RESTAURANT = "REACHED_RESTAURANT";
export const DELIVER_ORDER = "DELIVER_ORDER";
export const NOT_NEAR_CUSTOMER = "NOT_NEAR_CUSTOMER";
